const Routes = {
  MY_INSURANCE_DETAILS: { URL: "/my-insurance-details", showSidemenu: true },
  HOME: { URL: "/hem", showSidemenu: true },
  MY_INSURANCE: { URL: "/my-insurance", showSidemenu: true },
  FONDTORG: { URL: "/fondtorg", showSidemenu: true },
  SUPPORT: { URL: "/support", showSidemenu: true },
  MY_PROFILE: { URL: "/my-profile", showSidemenu: true },
  LOGIN: { URL: "/login" },
  NOTIFICATIONS: { URL: "/notifications", showSidemenu: true },
  WIZARD_START: { URL: "/start", isWizard: true },
  WIZARD_DISTRIBUTION: { URL: "/distribution", isWizard: true },
  WIZARD_CHANGE_FUND_PORTFOLIO: {
    URL: "/change-fund-portfolio",
    isWizard: true,
  },
  WIZARD_MANAGEMENT: { URL: "/management", isWizard: true },
  WIZARD_PREVIEW: { URL: "/preview", isWizard: true },
  WIZARD_FUNDS: { URL: "/add-funds", isWizard: true },
  WIZARD_SUCCESS: { URL: "/success", isWizard: true },
  WIZARD_ACCEPT_TERMS: { URL: "/acceptera-villkor", isWizard: true },
  FUND_PORTFOLIOS: { URL: "/fund-portfolios", showSidemenu: true },
  MY_FUND_PORTFOLIO_DETAILS: {
    URL: "/fund-portfolios-details",
    showSidemenu: true,
  },
  WIZARD_FUND_PORTFOLIO_DETAILS: {
    URL: "/portfolio",
    isWizard: true,
  },
  WIZARD_FUND_DETAILS: {
    URL: "/fund",
    isWizard: true,
  },
  FUND_DETAILS: { URL: "/fondtorg-details", showSidemenu: true },
  ABOUT_US: {
    URL: "/om-sfb",
    showSidemenu: true,
  },
  WP_CREATE_ACCOUNT: {
    URL: "https://minasidor.svenskafribrevsbolaget.se/inloggning",
  },
  PENDING_ORDERS: { URL: "/pending-orders" },
  CREATE_ACCOUNT: { URL: "/create-account" },
  LANDING_PAGE: { URL: "/" },
  INCORRECT_ACCOUNT: { URL: "/incorrect-account" },
  PUBLIC_FUND_PORTFOLIOS: {
    URL: "/fondportfoljer",
  },
  PUBLIC_MY_FUND_PORTFOLIO_DETAILS: {
    URL: "/fondportfoljer-:portfolioName",
  },
  ERROR_PAGE: {
    URL: "/error",
  },
  LOGOUT_PAGE: {
    URL: "/logout",
  },
  MAINTENANCE_PAGE: {
    URL: "/under-maintenance",
  },
};
export default Routes;
